import { Navigate, Route, Routes } from 'react-router-dom';

import { Report as PropertyReport } from '../../components';
import { useAuthContext } from '../../providers/AuthContextProvider';

export function Report() {
  const { status } = useAuthContext();

  if (status === 'unauthorized') {
    return <Navigate to={`/login?redirect=${window.location.pathname}`} />;
  }

  return (
    <>
      <Routes>
        <Route path=":id" element={<PropertyReport />} />
      </Routes>
    </>
  );
}

export default Report;
